import type { CustomField } from '@/api/customFields/customFields.interface';

// What a field's value rule means to the form that fills it in. The API sends
// `value_rule: { expression, default, locked }`; the config reads these three.
export interface FieldValueRule {
  // The formula this field calculates itself from, if it has one.
  formula?: string;
  // The value it starts at, when it isn't calculated.
  default_value?: string | number | boolean | null;
  // "Prevent edits": the filler can't type over the value.
  locked: boolean;
}

// A rule is absent for a field that has none, for a subject that can't carry
// one, and for an account with formula fields off — all of which read the same
// way here: no formula, no default, not locked.
export const readValueRule = (field?: Partial<CustomField>): FieldValueRule => {
  const rule = field?.value_rule;
  if (!rule) return { locked: false };

  const expression =
    typeof rule.expression === 'string' && rule.expression.trim() !== ''
      ? rule.expression
      : undefined;

  return {
    formula: expression,
    // A calculated field holds no default of its own.
    default_value: expression ? undefined : rule.default,
    locked: Boolean(rule.locked),
  };
};
